import React from "react"
import { getCompiler } from "../../../utils/MarkdownCompile"
import { TextLink } from "../atoms/links/TextLink"
import { elements } from "../DefaultMarkdown"
import { ZendeskTextLink } from "../atoms/links/ZendeskTextLink"
import { isZendeskLink } from "carrot-api/HelpCenterClient"

const newElements = {
  ...elements,
  p({ children }) {
    return <p className="invalid-red lh-copy mv4">{children}</p>
  },
  a({ href, title, target, children }) {
    if (isZendeskLink(href)) {
      return (
        <ZendeskTextLink target={target} title={title} to={href}>
          {children}
        </ZendeskTextLink>
      )
    }

    return (
      <TextLink to={href} target={target} title={title}>
        {children}
      </TextLink>
    )
  }
}

const md = getCompiler(newElements)

const ErrorMessageMarkdown = ({ source, additionalClasses = "", align = "tc" }) => (
  <div className={`m0-first-last-child ${align} ${additionalClasses ? additionalClasses : ""}`}>{md(source)}</div>
)

export default ErrorMessageMarkdown
